import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withKeys as _withKeys, unref as _unref, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/image/close-bg.png'
import _imports_1 from '../assets/image/zuanshi.png'
import _imports_2 from '../assets/image/search.png'
import _imports_3 from '../assets/image/close.png'
import _imports_4 from '../assets/image/menu-btn.png'


const _withScopeId = n => (_pushScopeId("data-v-817925c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "site-header-box" }
const _hoisted_2 = {
  key: 0,
  class: "advertisement top-ad"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "site-header" }
const _hoisted_5 = { class: "logo" }
const _hoisted_6 = { class: "head-menu" }
const _hoisted_7 = { class: "menu-item" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("首页")
const _hoisted_9 = { class: "menu-item" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("最新推荐")
const _hoisted_11 = { class: "menu-item" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("厂牌推荐")
const _hoisted_13 = { class: "menu-item" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 开店赚钱 ")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "充值送现金", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "header-right" }
const _hoisted_19 = { class: "search-head showSearchInput" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"22px","height":"22px","cursor":"pointer"},
  src: "https://pubimg-wfile.xiangsusheji.com/2024/04/11/14/07f2af4a-b519-46fb-932a-8798a0614837.png",
  alt: ""
}, null, -1))
const _hoisted_21 = { class: "hideSearchInput" }
const _hoisted_22 = { class: "avatar" }
const _hoisted_23 = {
  key: 0,
  src: _imports_3,
  alt: ""
}
const _hoisted_24 = {
  key: 1,
  src: _imports_4,
  alt: ""
}
const _hoisted_25 = {
  key: 0,
  class: "small-menu"
}
const _hoisted_26 = {
  key: 0,
  style: {"margin-bottom":"20px","display":"flex","justify-content":"space-between"}
}
const _hoisted_27 = { class: "list-head" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "user-info ml-10" }
const _hoisted_30 = { class: "name c0 fs-15 fw-500" }
const _hoisted_31 = {
  key: 0,
  class: "tag c-00B96B fs-10"
}
const _hoisted_32 = { class: "topup" }
const _hoisted_33 = { class: "unit c0" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "c9 mr-10 fs-10" }, "余额", -1))
const _hoisted_35 = { class: "price fw-bold fs-24" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("充值")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("登录/注册")
const _hoisted_38 = { style: {"display":"flex","justify-content":"space-between","margin-bottom":"20px"} }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"margin-top":"-5px"},
  src: _imports_1
}, null, -1))
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" 充值送现金")
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/_createTextVNode("首页")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("最新推荐")
const _hoisted_44 = /*#__PURE__*/_createTextVNode("厂牌推荐")
const _hoisted_45 = /*#__PURE__*/_createTextVNode("开店赚钱")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("个人中心")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("我的下载")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("我的收藏")
const _hoisted_49 = /*#__PURE__*/_createTextVNode("账号设置")
const _hoisted_50 = /*#__PURE__*/_createTextVNode("退出账号")

import logo from "@/components/logo/index.vue"; // @ is an alias to /src
import diySelect from "@/components/diy-select/index.vue"; // @ is an alias to /src
import websiteAvatarSelect from "@/components/website-avatar-select/index.vue";
import { store } from "@/store/index"
import { UserOutlined, SearchOutlined } from "@ant-design/icons-vue";
import { ref, onMounted, onUnmounted, watch } from "vue";
import request from '@/utils/request';

import { useRouter, useRoute } from 'vue-router'
import { message } from "ant-design-vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

if (localStorage.getItem('token')) {
  store.dispatch("getBalance")
}
const router = useRouter()
const route = useRoute()
const current = ref(['home']);
// 搜索文字
const searchText = ref<string>(route.query.searchText || '');
const searchCategory = ref<string>(route.query.pid || '');
// watch(() => searchCategory.value, (nv, ov) => {
//   if (nv) {
//     goSearch()
//   }
// })
//点击回车键搜索
const keyDown = (e: any) => {
  goSearch()
}
const goMobileSearch = () => {
  router.push({
    path: '/search/mobile',
  })
}
const goSearch = () => {

  // if (route.path == '/filtering') {
  //   if (searchCategory.value) {
  //     router.push({
  //       path: route.path,
  //       query: {
  //         ...route.query,
  //         searchText: searchText.value,
  //         pid: searchCategory.value
  //       }
  //     })
  //   } else {
  //     router.push({
  //       path: route.path,
  //       query: {
  //         ...route.query,
  //         searchText: searchText.value
  //       }
  //     })
  //   }

  // } else {
  //   router.push({
  //     path: '/search',
  //     query: {
  //       searchText: searchText.value
  //     }
  //   })
  // }
  // return
  searchCategory.value = route.query.pid || store.state.categoryType.value
  if (searchCategory.value) {
    router.push({
      path: '/filtering',
      query: {
        ...route.query,
        id: route.query.id || '',
        pid: searchCategory.value,
        searchText: searchText.value
      }
    })
  } else {
    if (!searchText.value) {
      message.error('请输入要搜索的关键词');
      return
    }
    router.push({
      path: '/search',
      query: {
        searchText: searchText.value
      }
    })
  }
}
const goPage = (url: any) => {
  isOpen.value = false
  router.push({
    path: url,
    query: {}
  })
}
const isOpen = ref<boolean>(false);
const menuClick = (e: any) => {
  console.log(e);
  isOpen.value = false
}
const showConfirm = ref(false);
const logout = (e: any) => {
  showConfirm.value = true
}
const handleOk = () => {
  request.post('/login/logout').then(res => {
    if (res && res.code === 200) {
      router.push({ path: "login" })
      localStorage.clear();
      store.commit("setUserInfo", null)
    }
  });
}
// 顶部弹框
const modelAgArr = ref<any[]>([])
const modelAgShow = ref<Boolean>(false)
request.get("/home/getAdvList", { type: 1 }).then((res: any) => {
  if (res && res.code == 200) {
    modelAgArr.value = res.result
    if (res.result && res.result.length > 0) {
      modelAgShow.value = true
    }
  }
})
const goAd = (url: any) => {
  window.open(url)
}


const isScrolledToTop = ref(true);
const isScrolledHeight = ref(0)

const handleScroll = () => {
  isScrolledToTop.value = window.scrollY === 0;
  isScrolledHeight.value = isScrolledToTop.value ? 60 : 0
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
  handleScroll()
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (modelAgShow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "close",
            src: _imports_0,
            alt: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (modelAgShow.value = false))
          }),
          _createElementVNode("img", {
            class: "ad-img",
            src: modelAgArr.value[0]?.pictureUrl,
            alt: "",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (goAd(modelAgArr.value[0]?.linkUrl)))
          }, null, 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(logo)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_router_link, { to: "/index" }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_router_link, { to: "/latest" }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_router_link, { to: "/recommend" }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_router_link, { to: "/uploadInt" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_badge, { count: "0佣金" }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", {
        class: "head-recharge-btn",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (goPage('/recharge/price')))
      }, _hoisted_17),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(diySelect, {
            class: "diy-select",
            modelValue: searchCategory.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (searchCategory.value = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_a_input, {
            class: "search-input",
            value: searchText.value,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (searchText.value = $event)),
            placeholder: "",
            onKeydown: _withKeys(keyDown, ["enter"])
          }, {
            suffix: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          }, 8, ["value", "onKeydown"])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("img", {
            src: _imports_2,
            alt: "",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (goMobileSearch()))
          })
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(websiteAvatarSelect)
        ]),
        _createElementVNode("div", {
          class: "menu-btn",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (isOpen.value = !isOpen.value))
        }, [
          (isOpen.value)
            ? (_openBlock(), _createElementBlock("img", _hoisted_23))
            : (_openBlock(), _createElementBlock("img", _hoisted_24))
        ])
      ]),
      (isOpen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            (_unref(store).state.userInfo?.avatar)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("img", {
                      class: "small-avatar",
                      src: _unref(store).state.userInfo?.avatar,
                      alt: ""
                    }, null, 8, _hoisted_28),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(store).state.userInfo?.realname), 1),
                      (_unref(store).state.userInfo?.brandTitle)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_unref(store).state.userInfo?.brandTitle), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(store).state.myBalance?.rechargeAmount), 1)
                    ]),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      class: "fs-13 ml-20",
                      size: "small",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (goPage('/recharge/price'))),
                      style: {"min-width":"57px","height":"28px"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_36
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : (_openBlock(), _createBlock(_component_a_button, {
                  key: 1,
                  style: {"width":"100%","margin-bottom":"20px"},
                  type: "primary",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (goPage('/login')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_37
                  ]),
                  _: 1
                })),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", {
                class: "menu-bg-btn",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (goPage('/my/home')))
              }, "开店赚钱"),
              _createElementVNode("div", {
                class: "menu-bg-btn blk-btn",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (goPage('/recharge/price')))
              }, _hoisted_41)
            ]),
            _createVNode(_component_a_menu, {
              selectedKeys: current.value,
              "onUpdate:selectedKeys": _cache[11] || (_cache[11] = ($event: any) => (current.value = $event)),
              mode: "inline",
              onClick: menuClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_menu_item, { key: "home" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: "/index" }, {
                      default: _withCtx(() => [
                        _hoisted_42
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_menu_item, { key: "last" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: "/latest" }, {
                      default: _withCtx(() => [
                        _hoisted_43
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_menu_item, { key: "brand" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: "/recommend" }, {
                      default: _withCtx(() => [
                        _hoisted_44
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_menu_item, { key: "openShop" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: "/uploadInt" }, {
                      default: _withCtx(() => [
                        _hoisted_45
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_sub_menu, { key: "my" }, {
                  title: _withCtx(() => [
                    _hoisted_46
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_menu_item, { key: "download" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, { to: "/my/download" }, {
                          default: _withCtx(() => [
                            _hoisted_47
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_menu_item, { key: "collect" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, { to: "/my/collect" }, {
                          default: _withCtx(() => [
                            _hoisted_48
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_menu_item, { key: "setting" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, { to: "/my/setting" }, {
                          default: _withCtx(() => [
                            _hoisted_49
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_unref(store).state.userInfo?.avatar)
                      ? (_openBlock(), _createBlock(_component_a_menu_item, {
                          key: "out",
                          onClick: logout
                        }, {
                          default: _withCtx(() => [
                            _hoisted_50
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["selectedKeys"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_a_modal, {
        visible: showConfirm.value,
        "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => (showConfirm.value = $event)),
        title: "确认退出账号吗",
        okText: "确认",
        cancelText: "取消",
        closable: false,
        onOk: handleOk
      }, null, 8, ["visible"])
    ])
  ]))
}
}

})